/**
 * Center types — TS mirror of the Flutter `core/models/center.dart` and
 * the `cargo_delivery_centers` table columns.
 */

export type CenterStatus = 'pending' | 'approved' | 'rejected';

export interface OperatingHoursPerDay {
  sunday?: string;    // "09:00-18:00" | "closed"
  monday?: string;
  tuesday?: string;
  wednesday?: string;
  thursday?: string;
  friday?: string;
  saturday?: string;
}

export interface Center {
  id: number;
  name: string;
  name_ar?: string;
  address: string;
  city: string;
  city_id?: number;
  country: string;
  lat: number;
  lng: number;
  phone?: string;
  email?: string;
  operating_hours?: string | OperatingHoursPerDay;
  is_24_hours?: boolean;
  manager_id: string;
  manager_name?: string;
  max_storage_weight?: number | null;
  has_refrigeration?: boolean;
  notes?: string;
  status: CenterStatus;
  rejection_reason?: string | null;
  paused_until?: string | null;
  pause_reason?: string | null;
  storefront_photo_url?: string;
  exterior_photo_url?: string;
  interior_photo_url?: string;
  surroundings_photo_url?: string;
  is_active?: boolean;
  is_verified?: boolean;
  owner_verified?: boolean;
  rating_avg?: number;
  rating_count?: number;
  active_shipments_count?: number;
  total_shipments_count?: number;
  distance_km?: number;
  created_at: string;
  updated_at?: string;
}

export interface CenterRating {
  id: number;
  center_id: number;
  user_id: string;
  user_name?: string;
  shipment_id?: number;
  rating: number;
  comment?: string;
  created_at: string;
}

export interface CenterOperator {
  user_id: string;
  user_name?: string;
  user_phone?: string;
  role: 'owner' | 'operator';
  invited_by?: string;
  accepted_at?: string;
  invited_at: string;
}

export function isCenterPaused(c: Center): boolean {
  if (!c.paused_until) return false;
  return new Date(c.paused_until).getTime() > Date.now();
}
